import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deleteJob, listJob, jobStatus } from './JobServices';

const JobList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "id", label: "ID", minWidth: 170 },
        { key: "job_title", label: "Job Title", minWidth: 170 },
        { key: "location", label: "Location", minWidth: 170 },
        { key: "job_description", label: "Job Description", minWidth: 170 },

    ];

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        listJob().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Job List' list={true} link={PageRoutes.JOB_ADD} value={"Add Job"} />
                            <CMTableList
                                // exportFileName="Office Branch"
                                // csvHeaders={["ID", "Name", "Removed"]}
                                // csvHeaderKeys={["id", "name", "removed"]}
                                blockService={jobStatus}
                                listService={listJob}
                                deleteService={deleteJob}
                                showView={false}
                                showBlock={false}
                                editLink={PageRoutes.JOB_EDIT}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default JobList;
